import * as React from 'react';
import { ReactElement } from 'react';
import Videojs from '../presentationVideo.js';

import { Chip, Grid, Paper } from '@mui/material';

import './ProjectPageStyles.css';

const videoJsOptions = {
    autoplay: false,
    preload: "auto",
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
    width: 720,
    height: 300,
    controls: true,
    poster: "./thumbnails/thumbnail_full_video.png",
    sources: [
      {
        src: './videos/error404hci_presentation.mp4',
        type: 'video/mp4',
      },
    ],
  };


export interface IItemCardFullWidthProps {
    headerAvatar: ReactElement;
    headerLabel: string;
}

const ItemCardFullWidth = (props: IItemCardFullWidthProps) => {

    const { headerAvatar, headerLabel } = props;

    return(
        <>
            <link
            href="https://unpkg.com/@videojs/themes@1/dist/city/index.css"
            rel="stylesheet"
            />
            <link href="https://vjs.zencdn.net/7.17.0/video-js.css" rel="stylesheet" />
            <Paper className="item-card-paper-full-width" elevation={24}>
                <Grid className="item-paper-content-grid-container-full-width" container direction="column" justifyContent="center">
                    <Grid className="item-paper-content-grid-body-full-width" item>
                        <Chip color="error" icon={headerAvatar} label={headerLabel} />
                    </Grid>
                    <Grid item style={{height: "2vw", width: "100%"}} />
                    <Grid className="item-paper-content-grid-body-full-width item-paper-video-content" item>
                        <Videojs {...videoJsOptions} />
                    </Grid>
                    <Grid className="presentation-viewer-divider-item" item>
                        <div className="presentation-viewer-divider" />
                    </Grid>
                    <Grid className="item-paper-content-grid-body-full-width" item xs={1}>
                        <img src="poster.svg" width="100%" height="100%" alt="" />
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default ItemCardFullWidth;